type DiagramTypeOption = {
  id: string;
  label: string;
  prefix: string;
};

const DIAGRAM_TYPES: DiagramTypeOption[] = [
  { id: 'flowchart', label: 'Flowchart', prefix: 'Create a flowchart that shows' },
  { id: 'sequence', label: 'Sequence', prefix: 'Create a sequence diagram for' },
  { id: 'class', label: 'Class', prefix: 'Create a class diagram for' },
  { id: 'er', label: 'ER Diagram', prefix: 'Create an ER diagram for' },
  { id: 'state', label: 'State', prefix: 'Create a state diagram for' },
  { id: 'gantt', label: 'Gantt', prefix: 'Create a Gantt chart for' },
  { id: 'mindmap', label: 'Mind Map', prefix: 'Create a mind map for' },
  { id: 'pie', label: 'Pie Chart', prefix: 'Create a pie chart showing' },
  { id: 'architecture', label: 'Architecture', prefix: 'Create a system architecture diagram for' },
  { id: 'git', label: 'Git Graph', prefix: 'Create a git graph showing' },
];

type DiagramTypeSelectorProps = {
  onSelectType: (prefix: string) => void;
};

export function DiagramTypeSelector({ onSelectType }: DiagramTypeSelectorProps) {
  return (
    <div className="ds-diagram-types">
      {DIAGRAM_TYPES.map((dt) => (
        <button
          key={dt.id}
          type="button"
          className="ds-diagram-types__pill"
          onClick={() => onSelectType(dt.prefix + ' ')}
        >
          {dt.label}
        </button>
      ))}
    </div>
  );
}
